module.exports = __webpack_public_path__ + "static/media/galerija_2017 (35).990ff31e.jpg";